import { usePathname, useRouter } from "expo-router"
import React from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet } from "react-native"
import { SafeAreaView } from "react-native-safe-area-context"

import { SignOutButton } from "@/components/Auth"
import { FarmHqLogo } from "@/components/FarmHqLogo"
import { DevOnly } from "@/components/makeFilterComponent"
import { AppText, Button, Heading, SPACING, testIds, View } from "@/theme"

function NotFoundScreen(): React.JSX.Element {
  const { t } = useTranslation("errors")

  const router = useRouter()
  const pathname = usePathname()
  return (
    <SafeAreaView {...testIds("notFound")} style={styles.root}>
      <View style={styles.inner}>
        <FarmHqLogo
          name={"farmhq-logo-stacked.png"}
          resizeMode={"contain"}
          style={styles.logo}
          width={300}
        />
        <Heading variant={"h2"}>{t("notFoundTitle")}</Heading>
        <AppText colorScheme={"secondary"}>{t("notFoundMessage")}</AppText>
        <DevOnly>
          <AppText colorScheme={"secondary"}>{pathname}</AppText>
        </DevOnly>
        {router.canGoBack() ? (
          <Button
            IconComponent={"ArrowLeft"}
            text={t("back", { ns: "common" })}
            onPress={() => {
              router.back()
            }}
          />
        ) : (
          <Button
            text={t("home", { ns: "common" })}
            onPress={() => router.navigate("/")}
          />
        )}
        <SignOutButton />
      </View>
    </SafeAreaView>
  )
}
const styles = StyleSheet.create({
  inner: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: 500,
    justifyContent: "space-between",
    marginHorizontal: "auto",
    marginTop: 100,
    width: "100%",
  },
  logo: {
    height: 225,
    marginBottom: 20,
    width: 350,
  },
  root: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    paddingHorizontal: SPACING.$4,
    // justifyContent: "center",
  },
})

export default NotFoundScreen
